import type {
  HubAlgorithmDefinition,
  HubDatapoolDependency,
} from '@robovision/hub'
import {
  JobBaseDependency,
  type JobBaseDependencyParams,
} from './JobBaseDependency'


export interface JobDatapoolDependencyParams extends JobBaseDependencyParams {
  exampleDefinition: string
}

export class JobDatapoolDependency extends JobBaseDependency {
  public exampleDefinition: string

  protected constructor (params: JobDatapoolDependencyParams) {
    super(params)
    this.exampleDefinition = params.exampleDefinition
  }

  public static fromDefinition (
    datapoolDependency: HubDatapoolDependency,
    algorithmDefinition: HubAlgorithmDefinition,
  ) {
    const datapoolDef = algorithmDefinition.datapoolDefinitions?.find(
      (def) => def.id === datapoolDependency.datapoolDefinition,
    )

    if (!datapoolDef) {
      throw new Error(
        `Invalid schema. Datapool definition ${datapoolDependency.datapoolDefinition} not found`,
      )
    }

    return new JobDatapoolDependency({
      definitionId: datapoolDef.id,
      dependencyId: datapoolDependency.id,
      description: datapoolDependency.description,
      exampleDefinition: datapoolDef.exampleDefinition,
      name: datapoolDependency.name,
    })
  }
}
